import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgNonProfit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.005 17.008h2.334c.433 0 .854-.14 1.2-.4l2.418-1.813a1.516 1.516 0 011.98 2.284l-2.073 2.074c-.559.559-1.27.94-2.045 1.094l-2.931.587a4.002 4.002 0 01-1.756-.043L9.48 20.13a3.956 3.956 0 00-.97-.12H7.003m6.004-3.002h1.486c.837 0 1.516-.678 1.516-1.515v-.3c0-.695-.473-1.301-1.148-1.47l-2.293-.573a4.691 4.691 0 00-3.746.646l-1.817 1.212h-4v4.999h4M15.75 7.292L12 10 8.25 7.292A2.5 2.5 0 1112 4.009a2.499 2.499 0 014.317 2.436 2.5 2.5 0 01-.567.85",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export { SvgNonProfit as ReactComponent };
